import { createContext, useContext, useState, useEffect } from "react";

const SiteTextsContext = createContext({});
const API = process.env.REACT_APP_BACKEND_URL;

export function SiteTextsProvider({ children }) {
  const [texts, setTexts] = useState({});
  const [deliveryConfig, setDeliveryConfig] = useState({ auspost_content_visible: false });

  useEffect(() => {
    fetch(`${API}/api/settings/site-texts`)
      .then(r => r.json())
      .then(d => setTexts(d.texts || {}))
      .catch(() => {});

    fetch(`${API}/api/settings/delivery-config`)
      .then(r => r.json())
      .then(d => setDeliveryConfig(d))
      .catch(() => {});
  }, []);

  return (
    <SiteTextsContext.Provider value={{ texts, deliveryConfig }}>
      {children}
    </SiteTextsContext.Provider>
  );
}

export function useSiteTexts() {
  const ctx = useContext(SiteTextsContext);
  return ctx.texts || ctx;
}

export function useDeliveryConfig() {
  const ctx = useContext(SiteTextsContext);
  return ctx.deliveryConfig || { auspost_content_visible: false };
}

export function t(texts, key, fallback) {
  return texts[key] || fallback || key;
}
